module.exports = __webpack_public_path__ + "img/about.97ed216d.jpg";